<script>
export default {

}
</script>

<template>
  <ul class="footer-section">
    <slot/>
  </ul>
</template>

<style lang="scss">
@import '@design';

.footer-section {
  height: auto;

  & li {
    font-family: Open Sans, sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: white;
    margin-bottom: 10px;
    cursor: pointer;
  }
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $screen-width-xs) {
  .footer-section {
    margin-left: 8px !important;
  }
}
</style>
